<template>
  <BaseModal ref="modal">
    <UiModalDialog
      :no-footer="true"
      :has-bg-color="hasBgColor"
    >
      <template #header v-if="$slots.header">
        <slot name="header" />
      </template>
      <div class="jps-modal-content">
        <slot />
      </div>
    </UiModalDialog>
  </BaseModal>
</template>

<script lang="ts" setup>
import type { BaseModal } from '#components'

interface Props {
  hasBgColor?: 'gray' | 'white'
}
const props = withDefaults(defineProps<Props>(), {
})

const modal = ref<InstanceType<typeof BaseModal>>()
const openAwait = async () => {
  return await modal.value.openAwait<null>()
}
defineExpose({ openAwait })
</script>
